<template>
  <div class="package">
    <p>
      <upload
        @uploaded="onUpload"
        v-model="qrCodeUrl"
        :data="{ category: 'qr-code' }"
      >
        <!-- <a slot="content" class="edit-button">
          <i class="el-icon-edit"></i>
        </a>-->
      </upload>
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Upload from 'components/upload';

export default {
  name: 'qrcode',
  data() {
    return {
      qrCodeUrl: this.qrCodeInfo && this.qrCodeInfo[this.type]
    };
  },
  watch: {
    qrCodeInfo: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.qrCodeUrl = val && val[this.type];
        }
      },
      deep: true
    }
  },
  props: ['type'],
  computed: {
    ...mapState('qrcodes', ['qrCodeInfo'])
  },
  components: {
    Upload
  },
  methods: {
    ...mapActions('qrcodes', ['update', 'info']),
    onUpload() {
      this.update({
        type: this.type,
        url: this.qrCodeUrl
      }).then(() => {
        this.info();
      });
    }
  },
  created() {
    this.info();
  }
};
</script>

<style lang="less" scoped>
@import '~styles/variables.less';

.package {
  padding: 20px 0;
  margin-top: 20px;
  border-radius: 4px;
  padding: 20px;
  background-position: bottom right 10px;
  background-size: auto 100%;
  // background-color: #dcedc8;
  display: flex;
  align-items: center;
  flex-direction: row;
  p {
    display: flex;
    align-items: center;
    margin: 0;
    & + p {
      margin-top: 20px;
    }
    .link {
      text-decoration: underline;
    }
  }
}
</style>
